import { render, staticRenderFns } from "./suggestLocation.vue?vue&type=template&id=c4b3c7ca&"
import script from "./suggestLocation.vue?vue&type=script&lang=js&"
export * from "./suggestLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports